<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['create']);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 px-4">
    <div
      class="flex items-center justify-center w-16 h-16 mb-4 bg-n-alpha-2 rounded-full"
    >
      <span class="i-lucide-users text-3xl text-n-slate-10" />
    </div>
    <h2 class="text-lg font-semibold text-n-slate-12 mb-2">
      {{ t('CONTACT_LISTS.EMPTY_STATE.TITLE') }}
    </h2>
    <p class="text-sm text-n-slate-11 text-center max-w-md mb-6">
      {{ t('CONTACT_LISTS.EMPTY_STATE.SUBTITLE') }}
    </p>
    <Button icon="i-lucide-plus" color-scheme="primary" @click="emit('create')">
      {{ t('CONTACT_LISTS.NEW_LIST') }}
    </Button>
  </div>
</template>
